import { PlusIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";

import Button from "~/components/buttons/Button";
import { INVOICES_INDEX_PATH, INVOICES_PENDING_PATH } from "~/constants/appRoutes.ts";
import CreateInvoiceSidebar from "~/modules/billing/components/InvoicePageHeader/components/CreateInvoiceSidebar";

type Props = PropsWithChildren &{
	currentPage: "invoices" | "pending";
	userCanManageInvoices: boolean;
};

const InvoicePageHeader = ({
	currentPage,
	children,
	userCanManageInvoices,
}: Props) => {
	const [showCreateInvoiceSidebar, setShowCreateInvoiceSidebar] = useState<boolean>(false);

	return <div className="z-50 mx-auto mb-4 w-full space-y-4 bg-white px-8 py-4 ">
		<div className="flex items-center gap-x-2">
			{/*<CurrencyEuroIcon className="size-10 text-primary-700" />*/}
			<NavLink to={INVOICES_INDEX_PATH}
					 className={clsx("text-3xl font-bold transition-colors", currentPage === "invoices" ? "text-primary-700" : "text-primary-700/30 hover:text-danger-500")}>
				Rechnungen
			</NavLink>
			<span className="text-xl font-bold text-primary-700">|</span>
			<NavLink to={INVOICES_PENDING_PATH}
					 className={clsx("text-3xl font-bold transition-colors", currentPage === "pending" ? "text-primary-700" : "text-primary-700/30 hover:text-danger-500")}>
				Abrechenbares
			</NavLink>
			{userCanManageInvoices && <Button theme="secondary"
											  className="ml-auto"
											  onClick={() => setShowCreateInvoiceSidebar(true)}><PlusIcon className="size-5" />
			</Button>}
		</div>
		{children}

		{userCanManageInvoices && <CreateInvoiceSidebar isOpen={showCreateInvoiceSidebar}
														onClose={() => setShowCreateInvoiceSidebar(false)} />}
	</div>;
};

export default InvoicePageHeader;